import React from "react";

const CloseBtn = () => {
  return (
    <svg
      width="101"
      height="101"
      viewBox="0 0 101 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="25.0784"
        y1="25.0794"
        x2="75.2356"
        y2="75.2366"
        stroke="#9071AF"
        strokeWidth="5.5995"
      />
      <line
        x1="25.0798"
        y1="75.2371"
        x2="75.2371"
        y2="25.0799"
        stroke="#9071AF"
        strokeWidth="5.5995"
      />
    </svg>
  );
};

export default CloseBtn;
